import { render, staticRenderFns } from "./ClosedApplications.vue?vue&type=template&id=942f45de"
import script from "./ClosedApplications.vue?vue&type=script&lang=js"
export * from "./ClosedApplications.vue?vue&type=script&lang=js"
import style0 from "./ClosedApplications.vue?vue&type=style&index=0&id=942f45de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports